import useHub from "data/hub/useHub";

import evaluate from "./evaluate";
import useInsightInfos from "./useInsightInfos";

/*
  Example of a JSON value returned by the second LD variation:
  {
    "clientCardTabs": [],
    "workflowReportMenu": [],
    "reportButton": [
      {
        "dashboard": "active_client_workflows",
        "name": "Active Client Workflows",
        "predicates": "[
          { "path": "clientPool.type", "value": "hubly", "opr": "=" }
        ]"
      }
    ],
  }

  See https://app.launchdarkly.com/default/develop/features/looker-embedded-reports/variations
*/

export function useInsightInfosWithHub(type) {
  const hub = useHub();

  return useInsightInfos(type).filter(evaluate(hub));
}

export default useInsightInfosWithHub;
